import React from 'react';
import I18N from 'i18n-js';
import CsrfForm from '@reverbdotcom/commons/src/csrf_form';
import experiments from '@reverbdotcom/commons/src/experiments';
import { useUser, useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import { RCButton, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import { FlagIcon } from '@reverbdotcom/cadence/icons/react';
import { FLAG_LISTING_REASONS } from './shared/constants';
import UrlHelpers from '../shared/url_helpers';
import { ButtonVariant } from '@reverbdotcom/cadence/components/RCButton/styling';

interface IProps {
  listingId: string;
  fullWidth?: boolean;
  variant?: ButtonVariant;
}

export function Item2ReportMismatchedProduct({ listingId, fullWidth, variant = 'muted' }: IProps) {
  const user = useUser();
  const userIsBlocked = useExpEnabled(experiments.BLOCKED_FROM_FLAGGING_LISTINGS);
  const userIsNotPreferredSeller = !user?.isAdmin && !user?.preferredSeller;

  if (userIsBlocked || userIsNotPreferredSeller) return null;
  if (!listingId) return null;

  return (
    <CsrfForm
      action={UrlHelpers.flagListingsPath(listingId, FLAG_LISTING_REASONS.INCORRECT_CANONICAL_PRODUCT)}
      method="post"
      data-disable-auto-validation="true"
    >
      <RCButton
        size="small"
        variant={variant}
        isSubmit
        fullWidth={fullWidth}
      >
        <RCTextWithIcon
          placement="left"
          svgComponent={FlagIcon}
        >
          {I18N.t('discovery.adminButtons.reportMismatchedProduct')}
        </RCTextWithIcon>
      </RCButton>
    </CsrfForm>
  );
}
